export class SmartLineItem {
  Amount: number;
  AmountLocal: number;
  BetBuilderId: string;
  BetType?: number;
  CanBeEachWay: boolean;
  CountryId: string;
  Date?: string;
  Description: string;
  downOdd: boolean;
  EventDate: string;
  EventId: string;
  EventName: string;
  GameId: string;
  GameLocked?: boolean;
  GameSpecialOddsValue: string;
  Id: string;
  Index: number;
  IsLive: boolean;
  ItemId: number;
  LineErrorMessages: string[];
  LineErrors: string[];
  Name: string;
  NodeId: string;
  NotAvailable?: boolean;
  Odd: number;
  PotentialWin?: number;
  ResultsNr: string;
  Selected: boolean;
  SmartLineItems: SmartLineItemsItem[];
  SportHandle: string;
  TicketNumber?: string;
  TotalBets: number;
  TotalPotentialWin?: number;
  TotalPotentialWinWithoutBoost?: number;
  Type: number;
  upOdd: boolean;
}

export interface SmartLineItemsItem {
  GameName: string;
  Name: string;
  ResultId: string;
}

export const createSmartLineItem = (items, market, odds) => {
  const smartLineItem = new SmartLineItem();
  smartLineItem.Amount = 1;
  smartLineItem.AmountLocal = 1;
  smartLineItem.CanBeEachWay = false;
  smartLineItem.EventName = market.Name;
  smartLineItem.IsLive = market.isLive || false;
  smartLineItem.LineErrorMessages = [];
  smartLineItem.Odd = parseFloat(odds);
  smartLineItem.Selected = false;
  smartLineItem.SmartLineItems = [...items];
  smartLineItem.TotalPotentialWin = 0;
  return smartLineItem;
};

export const mapSmartLineItem = (item) => {
  const smartLineItem = new SmartLineItem();
  smartLineItem.Amount = 1;
  smartLineItem.AmountLocal = 1;
  smartLineItem.CanBeEachWay = false;
  smartLineItem.downOdd = item[0].downOdd;
  smartLineItem.EventDate = item[0].EventDate;
  smartLineItem.EventId = item[0].EventId;
  smartLineItem.EventName = item[0].EventName;
  smartLineItem.GameId = item[0].GameId;
  smartLineItem.IsLive = item[0].IsLive || false;
  smartLineItem.LineErrorMessages = [];
  smartLineItem.Odd = item[0].Odd;
  smartLineItem.ResultsNr = item[0].NodeId;
  smartLineItem.Selected = false;
  smartLineItem.SmartLineItems = [...item];
  smartLineItem.SportHandle = item[0].SportHandle;
  smartLineItem.TotalPotentialWin = 0;
  smartLineItem.upOdd = item[0].upOdd;
  return smartLineItem;
};
